import {types} from './types';

const setGetTransactionReportAction = (payload) => {
  return {
      type: types.SET_TRANSACTION_REPORT,
      payload,
    }
}

export {
  setGetTransactionReportAction
}
